import cookieDomain from "lib/cookieDomain"
import currentRegion from "lib/currentRegion"
import Cookies from "js-cookie"

const COOKIE_EXPIRATION_DAYS = 30
const COOKIE_NAME = "tc_region"

/**
 * Persists the `currentRegion()` resolved value into the `tc_region` cookie
 */
export default function rememberRegion() {
  currentRegion().then((regionCode) => {
    Cookies.set(COOKIE_NAME, regionCode, {
      domain: cookieDomain(),
      expires: COOKIE_EXPIRATION_DAYS,
      sameSite: "Lax",
    })
  })
}
